import { BrowserRouter as Router } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import './index.css'

// Páginas
const Dashboard = lazy(() => import('./pages/Dashboard'))
const Attendance = lazy(() => import('./pages/Attendance'))
const Produtividade = lazy(() => import('./pages/Produtividade'))
const Vision = lazy(() => import('./pages/Vision'))
const Settings = lazy(() => import('./pages/Settings'))

export default function App() {
  return (
    <Router>
      <Suspense fallback={<div>Carregando...</div>}>
        <Dashboard />
      </Suspense>
    </Router>
  )
}

